import { render, staticRenderFns } from "./CreateMovement.vue?vue&type=template&id=e78c62c0&scoped=true&"
import script from "./CreateMovement.vue?vue&type=script&lang=js&"
export * from "./CreateMovement.vue?vue&type=script&lang=js&"
import style0 from "./CreateMovement.vue?vue&type=style&index=0&id=e78c62c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78c62c0",
  null
  
)

export default component.exports